document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".js-header");
  const headerSecondaryBtn = document.querySelector(".js-secondary-btn");

  if (!header) return;

  const stickyEls = document.querySelectorAll(".o-grid__item--sticky");
  const isAdmin = document.body.classList.contains("admin-bar");

  const adminOffset = isAdmin ? 50 : 0;

  const stickyMargin = 16;

  let lastY = window.scrollY;
  let ticking = false;

  let isSticky = false;
  let isPinned = true;

  function isMenuOpen() {
    return header.classList.contains("open");
  }

  function isDesktop() {
    return window.innerWidth >= 780;
  }

  function setSticky(state) {
    isSticky = state;
    header.classList.toggle("is-sticky", state);
  }

  function setPinned(state) {
    isPinned = state;
    header.classList.toggle("is-pinned", state);

    if (isAdmin) {
      if (isSticky && state) {
        header.style.top = `${adminOffset}px`;
      } else {
        header.style.top = "0px";
      }
    }

    stickyEls.forEach(el => {
      if (isSticky && state) {
        el.style.top = "200px";
      } else {
        el.removeAttribute("style");
      }
    });
  }


  function update() {
    const y = window.scrollY;
    const direction = y < lastY ? "up" : "down";

    const stickyTrigger = header.offsetHeight + stickyMargin;

    if (!isSticky && y > stickyTrigger) {
      setSticky(true);
      setPinned(isMenuOpen() ? true : isPinned);
    } else if (isSticky && y <= stickyTrigger) {
      setSticky(false);
      setPinned(true);
      if (isAdmin && y === 0) header.style.top = "0px";
    }

    if (isSticky) {
      if (isMenuOpen()) {
        setPinned(true);
      } else {
        if (direction === "up" && !isPinned) {
          setPinned(true);
        } else if (direction === "down" && isPinned) {
          setPinned(false);
        }
      }
    } else {
      setPinned(true);
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function onResize() {
    update();
  }

  if (headerSecondaryBtn) {
    new MutationObserver(() => {
      headerSecondaryBtn.classList.toggle("c-button--dark", !isSticky || isMenuOpen());
    }).observe(header, { attributes: true, attributeFilter: ["class"] });
  }

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize, { passive: true });
});
